const ticketsComponent = {
	bindings: {
		title: '@'
	}
};

export default ticketsComponent;
